export class TrackEventRequest {
  event: string;
  domain: string;
  tags: Record<string, string>;

  constructor(event: string, domain: string, tags: Record<string, string>) {
    this.event = event;
    this.domain = domain;
    this.tags = tags;
  }
}
